import { createAsyncThunk } from "@reduxjs/toolkit";

import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { GetAllLoans, CreateNewLoan, GetEmployeeLoans, GetPendingLoans, UpdateLoan, DeleteLoan, ApproveLoan, RejectLoan, RecordLoanPayment, PauseLoanMonth, ResumeLoanMonth, GetLoanEMISchedule } from "helpers/api_method";

export const GetAllLoansList = createAsyncThunk("loans/GetAllLoansList", async () => {
    try {
        const response = await GetAllLoans();
        return response.data;
    } catch (error) {
        return error;
    }
});

export const GetEmployeeLoansList = createAsyncThunk("loans/GetEmployeeLoansList", async (employeeId: string) => {
    try {
        const response = await GetEmployeeLoans(employeeId);
        return response.data;
    } catch (error) {
        return error;
    }
});

export const GetPendingLoansList = createAsyncThunk("loans/GetPendingLoansList", async () => {
    try {
        const response = await GetPendingLoans();
        return response.data;
    } catch (error) {
        return error;
    }
});

export const addNewLoan = createAsyncThunk("loans/addNewLoan", async (event: any) => {
    try {
        const response = await CreateNewLoan(event);
        toast.success("Loan application created successfully", { autoClose: 2000 });
        return response.data;
    } catch (error) {
        toast.error("Loan application creation failed", { autoClose: 2000 });
        return error;
    }
});

export const updateExistingLoan = createAsyncThunk("loans/updateExistingLoan", async (event: any) => {
    try {
        const response = await UpdateLoan(event.id, event);
        toast.success("Loan updated successfully", { autoClose: 2000 });
        return response.data;
    } catch (error) {
        toast.error("Loan update failed", { autoClose: 2000 });
        return error;
    }
});

export const deleteExistingLoan = createAsyncThunk("loans/deleteExistingLoan", async (event: any) => {
    try {
        const response = await DeleteLoan(event.id);
        toast.success("Loan deleted successfully", { autoClose: 2000 });
        return response.data;
    } catch (error) {
        toast.error("Loan deletion failed", { autoClose: 2000 });
        return error;
    }
});

export const approveLoan = createAsyncThunk("loans/approveLoan", async (event: any) => {
    try {
        const response = await ApproveLoan(event.id, event);
        toast.success("Loan approved successfully", { autoClose: 2000 });
        return response.data;
    } catch (error) {
        toast.error("Loan approval failed", { autoClose: 2000 });
        return error;
    }
});

export const rejectLoan = createAsyncThunk("loans/rejectLoan", async (event: any) => {
    try {
        const response = await RejectLoan(event.id, event);
        toast.success("Loan rejected successfully", { autoClose: 2000 });
        return response.data;
    } catch (error) {
        toast.error("Loan rejection failed", { autoClose: 2000 });
        return error;
    }
});

export const recordLoanPayment = createAsyncThunk("loans/recordLoanPayment", async (event: any) => {
    try {
        const response = await RecordLoanPayment(event.id, event);
        toast.success("Payment recorded successfully", { autoClose: 2000 });
        return response.data;
    } catch (error) {
        toast.error("Payment recording failed", { autoClose: 2000 });
        return error;
    }
}); 

export const pauseLoanMonth = createAsyncThunk("loans/pauseLoanMonth", async (event: { id: string; month: string }) => {
    try {
        const response = await PauseLoanMonth(event.id, { month: event.month });
        toast.success("Deduction paused for selected month", { autoClose: 2000 });
        return response.data;
    } catch (error) {
        toast.error("Failed to pause deduction", { autoClose: 2000 });
        return error;
    }
});

export const resumeLoanMonth = createAsyncThunk("loans/resumeLoanMonth", async (event: { id: string; month: string }) => {
    try {
        const response = await ResumeLoanMonth(event.id, { month: event.month });
        toast.success("Deduction resumed for selected month", { autoClose: 2000 });
        return response.data;
    } catch (error) {
        toast.error("Failed to resume deduction", { autoClose: 2000 });
        return error;
    }
});

export const getLoanEMISchedule = createAsyncThunk("loans/getLoanEMISchedule", async (loanId: string) => {
    try {
        const response = await GetLoanEMISchedule(loanId);
        return response.data;
    } catch (error) {
        return error;
    }
});
